// document.addEventListener("DOMContentLoaded", function() {

// 	function myFunction(sliderArg) {
// 		try {
// 			document.querySelectorAll("variant-selects").forEach(vs => {
// 				if (typeof vs.onVariantChange === "function") vs.onVariantChange();
// 				if (vs.currentVariant?.featured_media?.id && typeof vs.setActiveMedia === "function") {
// 					vs.setActiveMedia(vs.currentVariant.featured_media.id);
// 				}
// 			});
// 			document.querySelectorAll("product-form").forEach(pf => {
// 				if (typeof pf.onVariantChange === "function") pf.onVariantChange();
// 			});
// 			if (window.theme && theme.MediaGallery && typeof theme.MediaGallery.init === "function") {
// 				theme.MediaGallery.init();
// 			}
// 		} catch (e) {
// 			console.error(e);
// 		}
// 	}

// 	const qs = (sel, ctx = document) => ctx.querySelector(sel);
// 	const qsa = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
// 	const setHTMLAll = (sel, html) => qsa(sel).forEach(el => {
// 		el.innerHTML = html;
// 	});
// 	const setDisplayAll = (sel, value) => qsa(sel).forEach(el => {
// 		el.style.display = value;
// 	});
// 	const addClass = (el, cls) => {
// 		if (el && !el.classList.contains(cls)) el.classList.add(cls);
// 	};
// 	const removeClass = (el, cls) => {
// 		if (el && el.classList.contains(cls)) el.classList.remove(cls);
// 	};
// 	const removeClassAll = (sel, cls) => qsa(sel).forEach(el => removeClass(el, cls));
// 	const trimOrEmpty = v => (typeof v === 'string' ? v.trim() : '');

// 	const productSection = qs("#ProductSection-product-template");
// 	let pro_handle = productSection?.getAttribute("data-handle") ?? "";

// 	let firstDataOptionEl = qs('.first_clickyboxes_product li .active_data');
// 	let first_data_option = firstDataOptionEl?.getAttribute('data-value')?.trim();

// 	// ✅ Debounce flag to prevent multiple rapid calls
// 	let isProcessing = false;
// 	// ✅ NEW: Track last processed handle to prevent reload loops
// 	let lastProcessedHandle = null;

// 	// ✅ NEW: Disable/Enable all variant buttons
// 	function disableAllVariantButtons() {
// 		qsa('.product_option_data, .product_option_data_other').forEach(btn => {
// 			btn.style.pointerEvents = 'none';
// 			btn.style.opacity = '0.5';
// 			btn.setAttribute('disabled', 'true');
// 		});
// 		console.log("🔒 All variant buttons disabled");
// 	}

// 	function enableAllVariantButtons() {
// 		qsa('.product_option_data, .product_option_data_other').forEach(btn => {
// 			btn.style.pointerEvents = '';
// 			btn.style.opacity = '';
// 			btn.removeAttribute('disabled');
// 		});
// 		console.log("🔓 All variant buttons enabled");
// 	}

// 	// ✅ Button disabled check function (reusable)
// 	function checkButtonAndBadge() {
// 		const button = document.querySelector('.product-form form button');
// 		const badge = document.querySelector('.product__info-wrapper.grid__item .price span.badge.updated_sold_badge');

// 		if (button && badge) {
// 			if (button.hasAttribute('disabled')) {
// 				badge.classList.remove('hidden');
// 			} else {
// 				badge.classList.add('hidden'); 
// 			}
// 		}
// 	}

// 	// ✅ MOVED OUTSIDE: Main function accessible globally within DOMContentLoaded scope
// 	function applySelectionFromAnchor(anchor) {
// 		// ✅ Prevent duplicate calls
// 		if (isProcessing) {
// 			console.log("⏸️ Already processing, skipping duplicate call");
// 			return;
// 		}

// 		if (!anchor) return;

// 		const prodcut_handle = trimOrEmpty(anchor.getAttribute('data-value'));

// 		// ✅ NEW: Prevent processing same handle WHILE processing
// 		if (prodcut_handle === lastProcessedHandle && isProcessing === true) {
// 			console.log("⏸️ Same handle currently being processed:", prodcut_handle);
// 			return;
// 		}

// 		// ✅ Set processing flag IMMEDIATELY
// 		isProcessing = true;
// 		lastProcessedHandle = prodcut_handle;
		
// 		// ✅ NEW: Disable all buttons while processing
// 		disableAllVariantButtons();
		
// 		console.log("▶️ Starting applySelectionFromAnchor for:", prodcut_handle);

// 		const prodcut_varId = trimOrEmpty(anchor.getAttribute('data-varid'));
// 		const prodcut_id = trimOrEmpty(anchor.getAttribute('data-proid'));
// 		const prodcut_price = trimOrEmpty(anchor.getAttribute('data-price'));
// 		const prodcut_data_code = trimOrEmpty(anchor.getAttribute('data-code'));

// 		// Hidden input update
// 		const variantInput = qs('.product-variant-id');
// 		if (variantInput && prodcut_varId) {
// 			variantInput.value = prodcut_varId;
// 		}

// 		// ITG / variant-selects sync
// 		if (prodcut_varId) {
// 			const variantSelects = qs('variant-selects');
// 			if (variantSelects) {
// 				if (typeof variantSelects.selectVariant === 'function') {
// 					variantSelects.selectVariant(prodcut_varId);
// 				} else if (typeof variantSelects.updateOptionsFromExternal === 'function') {
// 					variantSelects.updateOptionsFromExternal(prodcut_varId);
// 				}
// 				// backup: sync the radio button
// 				qsa('input[name="id"]').forEach(radio => {
// 					if (radio.value === prodcut_varId) {
// 						radio.checked = true;
// 						radio.dispatchEvent(new Event('change', {
// 							bubbles: true
// 						}));
// 					}
// 				});
// 			}
// 		}

// 		// Price handling
// 		const priceElement = qs('.price__regular .price-item');
// 		const requestBtnRegister = qs('.request_codes_btn_register');

// 		if (prodcut_data_code !== '') {
// 			if (priceElement) priceElement.textContent = '';
// 			if (requestBtnRegister) requestBtnRegister.style.display = 'none';
// 		} else {
// 			if (priceElement) priceElement.innerHTML = prodcut_price || '';
// 			if (requestBtnRegister) requestBtnRegister.style.display = 'block';
// 		}

// 		if (prodcut_handle && prodcut_handle !== pro_handle) {
// 			window.__meta_active_handle = prodcut_handle;

// 			const productInfo = document.querySelector('product-info[data-newurl]');
// 			if (productInfo) {
// 				productInfo.setAttribute('data-url', `/products/${encodeURIComponent(prodcut_handle)}`);
// 			}
// 		}

// 		// Fetch product content
// 		if (prodcut_handle) {
// 			console.log("Fetching Product URL:", `/products/${encodeURIComponent(prodcut_handle)}`);
// 			fetch(`/products/${encodeURIComponent(prodcut_handle)}.js`)
// 				.then(r => r.json())
// 				.then(productJson => {
// 					if (productJson && productJson.variants) {
// 						const variantIDs = productJson.variants.map(v => v.id);
// 						console.log("All Variant IDs:", variantIDs);
// 						console.log("All Variants JSON:", productJson.variants);
// 					}
// 				})
// 				.catch(err => console.error("Variant JSON Fetch Error:", err));

// 			fetch(`/products/${encodeURIComponent(prodcut_handle)}`)
// 				.then(res => res.text())
// 				.then(responseText => {
// 					const parser = new DOMParser();
// 					const responseHTML = parser.parseFromString(responseText, "text/html");

// 					try {
// 						// Find variant JSON from fetched product
// 						const newVariantJSON = responseHTML.querySelector('script[data-selected-variant]:last-child')?.innerText;

// 						// Current product page JSON
// 						const currentVariantJSON = document.querySelector('variant-selects script[data-selected-variant]:last-child');

// 						if (newVariantJSON && currentVariantJSON) {
// 							currentVariantJSON.innerText = newVariantJSON;
// 							console.log("Updated Variant JSON:", JSON.parse(newVariantJSON));
// 						}
// 					} catch (err) {
// 						console.log("Variant JSON update error:", err);
// 					}

// 					const sliderElement = responseHTML.querySelector(".product__media-wrapper")?.innerHTML ?? null;
// 					const variantElement = responseHTML.querySelector(".ctm_variant_quantity_align")?.innerHTML ?? null;
// 					const quantityElement = responseHTML.querySelector(".quantity_alert_message")?.innerHTML ?? null;
// 					const priceContainerSwym = responseHTML.querySelector(".SwymGrPriceMain")?.innerHTML ?? null;

// 					if (quantityElement !== null) setHTMLAll('.quantity_alert_message', quantityElement);
// 					if (priceContainerSwym !== null) setHTMLAll('.SwymGrPriceMain', priceContainerSwym);
					
// 					// ✅ CRITICAL FIX: Only update variant HTML if it's different to prevent reload loop
// 					if (variantElement !== null) {
// 						const currentVariantHTML = qs('.ctm_variant_quantity_align')?.innerHTML;
						
// 						// Only update if content is actually different
// 						if (currentVariantHTML !== variantElement) {
// 							console.log("Updating variant HTML (content changed)");
// 							setHTMLAll('.ctm_variant_quantity_align', variantElement);
							
// 							// Re-init variant selects WITHOUT replacing the element
// 							setTimeout(() => {
// 								document.querySelectorAll("variant-selects").forEach(el => {
// 									try {
// 										if (typeof VariantSelects !== 'undefined' && VariantSelects.prototype.connectedCallback) {
// 											VariantSelects.prototype.connectedCallback.call(el);
// 										}
// 									} catch (err) {
// 										console.warn("VariantSelects re-init failed", err);
// 									}
// 								});
// 								console.log("Variant Selects Successfully Reinitialized.");
// 							}, 80);
// 						} else {
// 							console.log("⏭️ Skipping variant HTML update (no changes)");
// 						}
// 					}

// 					if (prodcut_data_code === '') {
// 						setDisplayAll('.request_codes_btn', 'none');
// 						const variantButtons = responseHTML.querySelector(".product-form__buttons")?.innerHTML;
// 						if (variantButtons) setHTMLAll('.product-form__buttons', variantButtons);
// 						setDisplayAll('.request_codes_btn_without', 'block');
// 					} else {
// 						setDisplayAll('.request_codes_btn_without', 'none');
// 						setDisplayAll('.request_codes_btn', 'block');
// 					}

// 					if (sliderElement !== null) {
// 						setHTMLAll('.product__media-wrapper', sliderElement);
// 						myFunction(sliderElement);
// 					}

// 					// ✅ Reset processing flag after fetch completes
// 					setTimeout(() => {
// 						isProcessing = false;
// 						lastProcessedHandle = null;
// 						enableAllVariantButtons();
// 						console.log("✅ Processing complete, ready for next call");
// 						// Badge check after full update
// 						checkButtonAndBadge();
// 					}, 3500);
// 				})
// 				.catch(err => {
// 					console.error("Fetch error:", err);
// 					isProcessing = false;
// 					lastProcessedHandle = null;
// 					enableAllVariantButtons();
// 					checkButtonAndBadge();
// 				});
// 		} else {
// 			// ✅ Reset flag if no fetch needed
// 			setTimeout(() => {
// 				isProcessing = false;
// 				lastProcessedHandle = null;
// 				enableAllVariantButtons();
// 				console.log("✅ Processing complete (no fetch), ready for next call");
// 				checkButtonAndBadge();
// 			}, 3500);
// 		}

// 		// Compare tabs
// 		qsa(".comapre_data").forEach(el => {
// 			const productFindId = el.getAttribute('data-product');
// 			if (String(productFindId) === String(prodcut_id)) {
// 				el.style.display = 'block';
// 				addClass(el, 'active');
// 			} else {
// 				el.style.display = 'none';
// 				removeClass(el, 'active');
// 			}
// 		});

// 		// Related products
// 		setTimeout(() => {
// 			const activeCompare = qs(".product__description.rte.quick-add-hidden.comapre_data.active");
// 			const recommProductID = activeCompare?.getAttribute("data-product");
// 			if (!recommProductID) return;

// 			const relatedEl = qs('.related-products');
// 			const recommProductURL = relatedEl?.getAttribute('data-url') ||
// 				`/recommendations/products?section_id=template--17435898708183__related-products&product_id=${recommProductID}&limit=4`;

// 			fetch(recommProductURL)
// 				.then(res => res.text())
// 				.then(text => {
// 					const parser = new DOMParser();
// 					const doc = parser.parseFromString(text, "text/html");
// 					const recommHtml = doc.querySelector("product-recommendations")?.innerHTML;
// 					if (recommHtml) setHTMLAll('product-recommendations', recommHtml);
// 				});
// 		}, 1500);
// 	}

// 	if (first_data_option) {
// 		const searchParams = new URLSearchParams(window.location.search);
// 		const param = searchParams.get('Type');
// 		if (param) {
// 			first_data_option = param;
// 			qsa(".first_clickyboxes_product li a").forEach(a => removeClass(a, 'active_data'));
// 			qsa(".first_clickyboxes_product li a").forEach(a => {
// 				const dataTag = a.getAttribute('data-value')?.trim();
// 				if (dataTag === first_data_option) {
// 					addClass(a, 'active_data');
// 					if (a.classList.contains('product_option_data_other')) {
// 						setDisplayAll('.plug_type_items', 'block');
// 					}
// 				}
// 			});

// 			const prohandle = qs('.product__info-container')?.getAttribute('data-handle');
// 			if (prohandle) {
// 				const newUrl = `${window.location.protocol}//${window.location.host}/products/${prohandle}`;
// 				history.replaceState({
// 					path: newUrl
// 				}, '', newUrl);
// 			}
// 		}

// 		function updateSecondOptions(selectedType) {
// 			removeClassAll(".second_clickyboxes_product li a", 'active');
// 			qsa(".second_clickyboxes_product li").forEach(li => li.classList.remove('other_option'));

// 			qsa('.second_clickyboxes_product li a').forEach(a => {
// 				const tags = a.getAttribute('data-tags')?.trim();
// 				if (tags === selectedType) {
// 					const li = a.closest('li');
// 					if (li) li.classList.add('other_option');
// 				}
// 			});

// 			const firstOtherAnchor = qsa('.second_clickyboxes_product li.other_option a')[0];
// 			if (firstOtherAnchor) addClass(firstOtherAnchor, 'active');
// 			return firstOtherAnchor;
// 		}

// 		let firstOtherAnchor = updateSecondOptions(first_data_option);

// 		/* ✅ DEFAULT COMPARE + VARIANT ACTIVATION ON PAGE LOAD (backup theme behavior) */
// 		if (firstOtherAnchor) {
// 			applySelectionFromAnchor(firstOtherAnchor);
// 		}

// 		/*  DEFAULT COMPARE-TAB ACTIVATION FIX */
// 		setTimeout(() => {
// 			const activeMetafieldAnchor = document.querySelector('.second_clickyboxes_product li a.active');

// 			if (activeMetafieldAnchor) {
// 				const defaultProdId = activeMetafieldAnchor.getAttribute("data-proid");

// 				if (defaultProdId) {
// 					document.querySelectorAll(".comapre_data").forEach(el => {
// 						const pid = el.getAttribute("data-product");
// 						if (String(pid) === String(defaultProdId)) {
// 							el.style.display = "block";
// 							el.classList.add("active");
// 						} else {
// 							el.style.display = "none";
// 							el.classList.remove("active");
// 						}
// 					});
// 				}
// 			}
// 		}, 500);

// 		const hasVariantParamOnLoad = new URLSearchParams(window.location.search).has('variant');
// 		const hasTypeParamOnLoad = new URLSearchParams(window.location.search).has('Type');

// 		if ((hasVariantParamOnLoad || hasTypeParamOnLoad) && firstOtherAnchor) {
// 			applySelectionFromAnchor(firstOtherAnchor);
// 		}

// 	}

// 	// ✅ PAGE LOAD / check after page reload
// 	checkButtonAndBadge();

// 	// ✅ Extra safety: check after variant check
// 	setTimeout(checkButtonAndBadge, 800);
// 	setTimeout(checkButtonAndBadge, 1000);
// 	setTimeout(checkButtonAndBadge, 2000);

// 	// FIRST LEVEL CLICK
// 	document.addEventListener("click", function(e) {
// 		const target = e.target.closest(".first_clickyboxes_product li a.product_option_data");
// 		if (!target) return;
// 		e.preventDefault();
// 		e.stopPropagation();

// 		if (window.location.search.includes("variant")) {
// 			const cleanURL = window.location.origin + window.location.pathname;
// 			history.replaceState({}, "", cleanURL);
// 		}

// 		removeClassAll(".first_clickyboxes_product li a", "active_data");
// 		addClass(target, 'active_data');

// 		if (target.classList.contains('last_type_option')) {
// 			removeClassAll(".product_option_data_other", "active_data");
// 			const firstOther = qsa('.product_option_data_other')[0];
// 			if (firstOther) addClass(firstOther, 'active_data');
// 			setDisplayAll('.plug_type_items', 'block');
// 		} else {
// 			setDisplayAll('.plug_type_items', 'none');
// 			removeClassAll(".product_option_data_other", "active_data");
// 		}

// 		const selectedType = target.getAttribute('data-value')?.trim();

// 		removeClassAll(".second_clickyboxes_product li", "other_option");
// 		removeClassAll(".second_clickyboxes_product li a", "active");

// 		const matching = qsa('.second_clickyboxes_product li a').filter(a =>
// 			a.getAttribute('data-tags')?.trim() === selectedType
// 		);

// 		matching.forEach(a => {
// 			const li = a.closest("li");
// 			if (li) li.classList.add("other_option");
// 		});

// 		const firstOtherAnchor = matching[0];
// 		if (firstOtherAnchor) addClass(firstOtherAnchor, "active");
// 		applySelectionFromAnchor(firstOtherAnchor);

// 		setTimeout(checkButtonAndBadge, 1200);
// 	});

// 	// SECOND LEVEL CLICK
// 	document.addEventListener("click", function(e) {
// 		const target = e.target.closest(".product_option_data_other");
// 		if (!target) return;

// 		e.preventDefault();
// 		e.stopPropagation();

// 		removeClassAll(".product_option_data_other", 'active_data');
// 		removeClassAll(".second_clickyboxes_product li a", "active");
// 		qsa(".second_clickyboxes_product li").forEach(li => li.classList.remove('other_option'));

// 		addClass(target, 'active_data');

// 		const selectedType = target.getAttribute('data-value')?.trim();

// 		qsa('.second_clickyboxes_product li a').forEach(a => {
// 			if (a.getAttribute('data-tags')?.trim() === selectedType) {
// 				const li = a.closest('li');
// 				if (li) li.classList.add('other_option');
// 			}
// 		});

// 		const firstOtherAnchor = qsa('.second_clickyboxes_product li.other_option a')[0];
// 		if (firstOtherAnchor) addClass(firstOtherAnchor, "active");

// 		applySelectionFromAnchor(firstOtherAnchor);

// 		setTimeout(checkButtonAndBadge, 1200);
// 	});

// 	// COMPARE TABS CLICK
// 	qsa(".comapre_data").forEach(el => {
// 		el.addEventListener("click", function() {
// 			qsa(".comapre_data").forEach(i => removeClass(i, 'active'));
// 			addClass(this, 'active');

// 			const prodId = this.getAttribute('data-product');
// 			if (!prodId) return;

// 			const relatedEl = qs('.related-products');
// 			const recommProductURL = relatedEl?.getAttribute('data-url') ||
// 				`/recommendations/products?section_id=template--17435898708183__related-products&product_id=${prodId}&limit=4`;

// 			fetch(recommProductURL)
// 				.then(res => res.text())
// 				.then(text => {
// 					const parser = new DOMParser();
// 					const doc = parser.parseFromString(text, "text/html");
// 					const recommHtml = doc.querySelector("product-recommendations")?.innerHTML;
// 					if (recommHtml) setHTMLAll('product-recommendations', recommHtml);
// 				});
// 		});
// 	});

// 	// BACK/FORWARD BUTTON + DIRECT LINK SUPPORT
// 	window.addEventListener('popstate', function(e) {
// 		if (e.state && e.state.variantId && e.state.handle && e.state.fromCustomTab) {
// 			const anchor = document.querySelector(`[data-varid="${e.state.variantId}"]`);
// 			if (anchor) {
// 				anchor.dispatchEvent(new Event('click', {
// 					bubbles: true
// 				}));
// 			}
// 		}
// 	});
// });




document.addEventListener("DOMContentLoaded", function() {

	function myFunction(sliderArg) {
		try {
			document.querySelectorAll("variant-selects").forEach(vs => {
				if (typeof vs.onVariantChange === "function") vs.onVariantChange();
				if (vs.currentVariant?.featured_media?.id && typeof vs.setActiveMedia === "function") {
					vs.setActiveMedia(vs.currentVariant.featured_media.id);
				}
			});
			document.querySelectorAll("product-form").forEach(pf => {
				if (typeof pf.onVariantChange === "function") pf.onVariantChange();
			});
			if (window.theme && theme.MediaGallery && typeof theme.MediaGallery.init === "function") {
				theme.MediaGallery.init();
			}
		} catch (e) {
			console.error(e);
		}
	}

	const qs = (sel, ctx = document) => ctx.querySelector(sel);
	const qsa = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
	const setHTMLAll = (sel, html) => qsa(sel).forEach(el => {
		el.innerHTML = html;
	});
	const setDisplayAll = (sel, value) => qsa(sel).forEach(el => {
		el.style.display = value;
	});
	const addClass = (el, cls) => {
		if (el && !el.classList.contains(cls)) el.classList.add(cls);
	};
	const removeClass = (el, cls) => {
		if (el && el.classList.contains(cls)) el.classList.remove(cls);
	};
	const removeClassAll = (sel, cls) => qsa(sel).forEach(el => removeClass(el, cls));
	const trimOrEmpty = v => (typeof v === 'string' ? v.trim() : '');

	const productSection = qs("#ProductSection-product-template");
	let pro_handle = productSection?.getAttribute("data-handle") ?? "";

	let firstDataOptionEl = qs('.first_clickyboxes_product li .active_data');
	let first_data_option = firstDataOptionEl?.getAttribute('data-value')?.trim();

	// ✅ Debounce flag to prevent multiple rapid calls
	let isProcessing = false;
	// ✅ NEW: Track last processed handle to prevent reload loops
	let lastProcessedHandle = null;

	// ✅ NEW: Disable/Enable all variant buttons
	function disableAllVariantButtons() {
		qsa('.product_option_data, .product_option_data_other').forEach(btn => {
			btn.style.pointerEvents = 'none';
			btn.style.opacity = '0.5';
			btn.setAttribute('disabled', 'true');
		});
		console.log("🔒 All variant buttons disabled");
	}

	function enableAllVariantButtons() {
		qsa('.product_option_data, .product_option_data_other').forEach(btn => {
			btn.style.pointerEvents = '';
			btn.style.opacity = '';
			btn.removeAttribute('disabled');
		});
		console.log("🔓 All variant buttons enabled");
	}

	// ✅ Button disabled check function (reusable)
	function checkButtonAndBadge() {
		const button = document.querySelector('.product-form form button');
		const badge = document.querySelector('.product__info-wrapper.grid__item .price span.badge.updated_sold_badge');

		if (button && badge) {
			if (button.hasAttribute('disabled')) {
				badge.classList.remove('hidden');
			} else {
				badge.classList.add('hidden'); 
			}
		}
	}

	// ✅ MOVED OUTSIDE: Main function accessible globally within DOMContentLoaded scope
	function applySelectionFromAnchor(anchor) {
		// ✅ Prevent duplicate calls
		if (isProcessing) {
			console.log("⏸️ Already processing, skipping duplicate call");
			return;
		}

		if (!anchor) return;

		const prodcut_handle = trimOrEmpty(anchor.getAttribute('data-value'));

		// ✅ NEW: Prevent processing same handle WHILE processing
		if (prodcut_handle === lastProcessedHandle && isProcessing === true) {
			console.log("⏸️ Same handle currently being processed:", prodcut_handle);
			return;
		}

		// ✅ Set processing flag IMMEDIATELY
		isProcessing = true;
		lastProcessedHandle = prodcut_handle;
		
		// ✅ NEW: Disable all buttons while processing
		disableAllVariantButtons();
		
		console.log("▶️ Starting applySelectionFromAnchor for:", prodcut_handle);

		const prodcut_varId = trimOrEmpty(anchor.getAttribute('data-varid'));
		const prodcut_id = trimOrEmpty(anchor.getAttribute('data-proid'));
		const prodcut_price = trimOrEmpty(anchor.getAttribute('data-price'));
		const prodcut_data_code = trimOrEmpty(anchor.getAttribute('data-code'));

		// Hidden input update
		const variantInput = qs('.product-variant-id');
		if (variantInput && prodcut_varId) {
			variantInput.value = prodcut_varId;
		}

		// ITG / variant-selects sync
		if (prodcut_varId) {
			const variantSelects = qs('variant-selects');
			if (variantSelects) {
				if (typeof variantSelects.selectVariant === 'function') {
					variantSelects.selectVariant(prodcut_varId);
				} else if (typeof variantSelects.updateOptionsFromExternal === 'function') {
					variantSelects.updateOptionsFromExternal(prodcut_varId);
				}
				// backup: sync the radio button
				qsa('input[name="id"]').forEach(radio => {
					if (radio.value === prodcut_varId) {
						radio.checked = true;
						radio.dispatchEvent(new Event('change', {
							bubbles: true
						}));
					}
				});
			}
		}

		// Price handling
		const priceElement = qs('.price__regular .price-item');
		const requestBtnRegister = qs('.request_codes_btn_register');

		if (prodcut_data_code !== '') {
			if (priceElement) priceElement.textContent = '';
			if (requestBtnRegister) requestBtnRegister.style.display = 'none';
		} else {
			if (priceElement) priceElement.textContent = prodcut_price || '';
			if (requestBtnRegister) requestBtnRegister.style.display = 'block';
		}

		if (prodcut_handle && prodcut_handle !== pro_handle) {
			window.__meta_active_handle = prodcut_handle;

			const productInfo = document.querySelector('product-info[data-newurl]');
			if (productInfo) {
				productInfo.setAttribute('data-url', `/products/${encodeURIComponent(prodcut_handle)}`);
			}
		}

		// Fetch product content
		if (prodcut_handle) {
			console.log("Fetching Product URL:", `/products/${encodeURIComponent(prodcut_handle)}`);
			fetch(`/products/${encodeURIComponent(prodcut_handle)}.js`)
				.then(r => r.json())
				.then(productJson => {
					if (productJson && productJson.variants) {
						const variantIDs = productJson.variants.map(v => v.id);
						console.log("All Variant IDs:", variantIDs);
						console.log("All Variants JSON:", productJson.variants);
					}
				})
				.catch(err => console.error("Variant JSON Fetch Error:", err));

			fetch(`/products/${encodeURIComponent(prodcut_handle)}`)
				.then(res => res.text())
				.then(responseText => {
					const parser = new DOMParser();
					const responseHTML = parser.parseFromString(responseText, "text/html");

					try {
						// Find variant JSON from fetched product
						const newVariantJSON = responseHTML.querySelector('script[data-selected-variant]:last-child')?.innerText;

						// Current product page JSON
						const currentVariantJSON = document.querySelector('variant-selects script[data-selected-variant]:last-child');

						if (newVariantJSON && currentVariantJSON) {
							currentVariantJSON.innerText = newVariantJSON;
							console.log("Updated Variant JSON:", JSON.parse(newVariantJSON));
						}
					} catch (err) {
						console.log("Variant JSON update error:", err);
					}

					const sliderElement = responseHTML.querySelector(".product__media-wrapper")?.innerHTML ?? null;
					const variantElement = responseHTML.querySelector(".ctm_variant_quantity_align")?.innerHTML ?? null;
					const quantityElement = responseHTML.querySelector(".quantity_alert_message")?.innerHTML ?? null;
					const priceContainerSwym = responseHTML.querySelector(".SwymGrPriceMain")?.innerHTML ?? null;

					if (quantityElement !== null) setHTMLAll('.quantity_alert_message', quantityElement);
					if (priceContainerSwym !== null) setHTMLAll('.SwymGrPriceMain', priceContainerSwym);
					
					// ✅ CRITICAL FIX: Only update variant HTML if it's different to prevent reload loop
					if (variantElement !== null) {
						const currentVariantHTML = qs('.ctm_variant_quantity_align')?.innerHTML;
						
						// Only update if content is actually different
						if (currentVariantHTML !== variantElement) {
							console.log("Updating variant HTML (content changed)");
							setHTMLAll('.ctm_variant_quantity_align', variantElement);
							
							// Re-init variant selects WITHOUT replacing the element
							setTimeout(() => {
								document.querySelectorAll("variant-selects").forEach(el => {
									try {
										if (typeof VariantSelects !== 'undefined' && VariantSelects.prototype.connectedCallback) {
											VariantSelects.prototype.connectedCallback.call(el);
										}
									} catch (err) {
										console.warn("VariantSelects re-init failed", err);
									}
								});
								console.log("Variant Selects Successfully Reinitialized.");
							}, 80);
						} else {
							console.log("⏭️ Skipping variant HTML update (no changes)");
						}
					}

					if (prodcut_data_code === '') {
						setDisplayAll('.request_codes_btn', 'none');
						const variantButtons = responseHTML.querySelector(".product-form__buttons")?.innerHTML;
						if (variantButtons) setHTMLAll('.product-form__buttons', variantButtons);
						setDisplayAll('.request_codes_btn_without', 'block');
					} else {
						setDisplayAll('.request_codes_btn_without', 'none');
						setDisplayAll('.request_codes_btn', 'block');
					}

					if (sliderElement !== null) {
						setHTMLAll('.product__media-wrapper', sliderElement);
						myFunction(sliderElement);
					}

					// ✅ Reset processing flag after fetch completes
					setTimeout(() => {
						isProcessing = false;
						lastProcessedHandle = null;
						enableAllVariantButtons();
						console.log("✅ Processing complete, ready for next call");
						// Badge check after full update
						checkButtonAndBadge();
					}, 500);
				})
				.catch(err => {
					console.error("Fetch error:", err);
					isProcessing = false;
					lastProcessedHandle = null;
					enableAllVariantButtons();
					checkButtonAndBadge();
				});
		} else {
			// ✅ Reset flag if no fetch needed
			setTimeout(() => {
				isProcessing = false;
				lastProcessedHandle = null;
				enableAllVariantButtons();
				console.log("✅ Processing complete (no fetch), ready for next call");
				checkButtonAndBadge();
			}, 500);
		}

		// Compare tabs
		qsa(".comapre_data").forEach(el => {
			const productFindId = el.getAttribute('data-product');
			if (String(productFindId) === String(prodcut_id)) {
				el.style.display = 'block';
				addClass(el, 'active');
			} else {
				el.style.display = 'none';
				removeClass(el, 'active');
			}
		});

		// Related products
		setTimeout(() => {
			const activeCompare = qs(".product__description.rte.quick-add-hidden.comapre_data.active");
			const recommProductID = activeCompare?.getAttribute("data-product");
			if (!recommProductID) return;

			const relatedEl = qs('.related-products');
			const recommProductURL = relatedEl?.getAttribute('data-url') ||
				`/recommendations/products?section_id=template--17435898708183__related-products&product_id=${recommProductID}&limit=4`;

			fetch(recommProductURL)
				.then(res => res.text())
				.then(text => {
					const parser = new DOMParser();
					const doc = parser.parseFromString(text, "text/html");
					const recommHtml = doc.querySelector("product-recommendations")?.innerHTML;
					if (recommHtml) setHTMLAll('product-recommendations', recommHtml);
				});
		}, 500);
	}

	if (first_data_option) {
		const searchParams = new URLSearchParams(window.location.search);
		const param = searchParams.get('Type');
		if (param) {
			first_data_option = param;
			qsa(".first_clickyboxes_product li a").forEach(a => removeClass(a, 'active_data'));
			qsa(".first_clickyboxes_product li a").forEach(a => {
				const dataTag = a.getAttribute('data-value')?.trim();
				if (dataTag === first_data_option) {
					addClass(a, 'active_data');
					if (a.classList.contains('product_option_data_other')) {
						setDisplayAll('.plug_type_items', 'block');
					}
				}
			});

			const prohandle = qs('.product__info-container')?.getAttribute('data-handle');
			if (prohandle) {
				const newUrl = `${window.location.protocol}//${window.location.host}/products/${prohandle}`;
				history.replaceState({
					path: newUrl
				}, '', newUrl);
			}
		}

		function updateSecondOptions(selectedType) {
			removeClassAll(".second_clickyboxes_product li a", 'active');
			qsa(".second_clickyboxes_product li").forEach(li => li.classList.remove('other_option'));

			qsa('.second_clickyboxes_product li a').forEach(a => {
				const tags = a.getAttribute('data-tags')?.trim();
				if (tags === selectedType) {
					const li = a.closest('li');
					if (li) li.classList.add('other_option');
				}
			});

			const firstOtherAnchor = qsa('.second_clickyboxes_product li.other_option a')[0];
			if (firstOtherAnchor) addClass(firstOtherAnchor, 'active');
			return firstOtherAnchor;
		}

		let firstOtherAnchor = updateSecondOptions(first_data_option);

		/* ✅ DEFAULT COMPARE + VARIANT ACTIVATION ON PAGE LOAD (backup theme behavior) */
		if (firstOtherAnchor) {
			applySelectionFromAnchor(firstOtherAnchor);
		}

		/*  DEFAULT COMPARE-TAB ACTIVATION FIX */
		setTimeout(() => {
			const activeMetafieldAnchor = document.querySelector('.second_clickyboxes_product li a.active');

			if (activeMetafieldAnchor) {
				const defaultProdId = activeMetafieldAnchor.getAttribute("data-proid");

				if (defaultProdId) {
					document.querySelectorAll(".comapre_data").forEach(el => {
						const pid = el.getAttribute("data-product");
						if (String(pid) === String(defaultProdId)) {
							el.style.display = "block";
							el.classList.add("active");
						} else {
							el.style.display = "none";
							el.classList.remove("active");
						}
					});
				}
			}
		}, 500);

		const hasVariantParamOnLoad = new URLSearchParams(window.location.search).has('variant');
		const hasTypeParamOnLoad = new URLSearchParams(window.location.search).has('Type');

		if ((hasVariantParamOnLoad || hasTypeParamOnLoad) && firstOtherAnchor) {
			applySelectionFromAnchor(firstOtherAnchor);
		}

	}

	// ✅ PAGE LOAD / check after page reload
	checkButtonAndBadge();

	// ✅ Extra safety: check after variant check
	setTimeout(checkButtonAndBadge, 800);
	setTimeout(checkButtonAndBadge, 1000);
	setTimeout(checkButtonAndBadge, 2000);

	// FIRST LEVEL CLICK
	document.addEventListener("click", function(e) {
		const target = e.target.closest(".first_clickyboxes_product li a.product_option_data");
		if (!target) return;
		e.preventDefault();
		e.stopPropagation();

		if (window.location.search.includes("variant")) {
			const cleanURL = window.location.origin + window.location.pathname;
			history.replaceState({}, "", cleanURL);
		}

		removeClassAll(".first_clickyboxes_product li a", "active_data");
		addClass(target, 'active_data');

		if (target.classList.contains('last_type_option')) {
			removeClassAll(".product_option_data_other", "active_data");
			const firstOther = qsa('.product_option_data_other')[0];
			if (firstOther) addClass(firstOther, 'active_data');
			setDisplayAll('.plug_type_items', 'block');
		} else {
			setDisplayAll('.plug_type_items', 'none');
			removeClassAll(".product_option_data_other", "active_data");
		}

		const selectedType = target.getAttribute('data-value')?.trim();

		removeClassAll(".second_clickyboxes_product li", "other_option");
		removeClassAll(".second_clickyboxes_product li a", "active");

		const matching = qsa('.second_clickyboxes_product li a').filter(a =>
			a.getAttribute('data-tags')?.trim() === selectedType
		);

		matching.forEach(a => {
			const li = a.closest("li");
			if (li) li.classList.add("other_option");
		});

		const firstOtherAnchor = matching[0];
		if (firstOtherAnchor) addClass(firstOtherAnchor, "active");
		applySelectionFromAnchor(firstOtherAnchor);

		setTimeout(checkButtonAndBadge, 1200);
	});

	// SECOND LEVEL CLICK
	document.addEventListener("click", function(e) {
		const target = e.target.closest(".product_option_data_other");
		if (!target) return;

		e.preventDefault();
		e.stopPropagation();

		removeClassAll(".product_option_data_other", 'active_data');
		removeClassAll(".second_clickyboxes_product li a", "active");
		qsa(".second_clickyboxes_product li").forEach(li => li.classList.remove('other_option'));

		addClass(target, 'active_data');

		const selectedType = target.getAttribute('data-value')?.trim();

		qsa('.second_clickyboxes_product li a').forEach(a => {
			if (a.getAttribute('data-tags')?.trim() === selectedType) {
				const li = a.closest('li');
				if (li) li.classList.add('other_option');
			}
		});

		const firstOtherAnchor = qsa('.second_clickyboxes_product li.other_option a')[0];
		if (firstOtherAnchor) addClass(firstOtherAnchor, "active");

		applySelectionFromAnchor(firstOtherAnchor);

		setTimeout(checkButtonAndBadge, 1200);
	});

	// COMPARE TABS CLICK
	qsa(".comapre_data").forEach(el => {
		el.addEventListener("click", function() {
			qsa(".comapre_data").forEach(i => removeClass(i, 'active'));
			addClass(this, 'active');

			const prodId = this.getAttribute('data-product');
			if (!prodId) return;

			const relatedEl = qs('.related-products');
			const recommProductURL = relatedEl?.getAttribute('data-url') ||
				`/recommendations/products?section_id=template--17435898708183__related-products&product_id=${prodId}&limit=4`;

			fetch(recommProductURL)
				.then(res => res.text())
				.then(text => {
					const parser = new DOMParser();
					const doc = parser.parseFromString(text, "text/html");
					const recommHtml = doc.querySelector("product-recommendations")?.innerHTML;
					if (recommHtml) setHTMLAll('product-recommendations', recommHtml);
				});
		});
	});

	// BACK/FORWARD BUTTON + DIRECT LINK SUPPORT
	window.addEventListener('popstate', function(e) {
		if (e.state && e.state.variantId && e.state.handle && e.state.fromCustomTab) {
			const anchor = document.querySelector(`[data-varid="${e.state.variantId}"]`);
			if (anchor) {
				anchor.dispatchEvent(new Event('click', {
					bubbles: true
				}));
			}
		}
	});
});